import editableComponentsListSelector from 'app/Can/selectors/editableComponentsList';
import componentSelector from 'app/Canvas/selectors/component';
import { clearSearch } from 'app/Search/actions';
import { addFilter } from 'app/Search/thunks';
import cwdSiteRootSelector from 'app/Tree/selectors/cwdSiteRoot';
import lanIdSelector from 'app/UserInfo/selectors/lanId';
import connect from 'utils/store/connect';

import contractMapSelector from 'app/App/selectors/contractMap';
import AttachChildModal from './components/AttachChildModal';

/**
 * map redux state to props
 * @param {object} state - redux state
 * @returns {object} component props
 */
export const mapState = state => ({
  componentDetails: componentSelector(state),
  componentsList: editableComponentsListSelector(state),
  cwdSiteRoot: cwdSiteRootSelector(state),
  contractMap: contractMapSelector(state),
  lanId: lanIdSelector(state)
});

const mapDispatch = {
  addFilter,
  clearSearch
};

export default connect(mapState, mapDispatch)(AttachChildModal);
